export var TranslationsFamily;
(function (TranslationsFamily) {
    TranslationsFamily["TRANS_SE"] = "trans__se";
    TranslationsFamily["TRANS_FINCALC"] = "trans__fincalc";
    TranslationsFamily["TRANS_MYACCOUNT"] = "trans__myaccount";
    TranslationsFamily["TRANS_CONFIGURATOR"] = "trans__configurator";
    TranslationsFamily["TRANS_TRADEIN"] = "trans__tradein";
    TranslationsFamily["TRANS_CHECKOUT"] = "trans__checkout";
    TranslationsFamily["TRANS_INSURANCE"] = "trans__insurance";
})(TranslationsFamily || (TranslationsFamily = {}));
//# sourceMappingURL=TranslationsFamily.js.map